import React from 'react';
import InstanceSearch from './InstanceSearch';

export default props => <InstanceSearch {...props} />;
